export default __webpack_public_path__ + "static/media/tech_4.3ac76118.png";